import React from 'react';
import PropTypes from 'prop-types';
import Container from '../Container/Container';
import style from './StockHeader.module.css';
import StockImg from '../StockImg/StockImg';
import StockFollowButton from '../StockFollowButton/StockFollowButton';

const insiderInformationSubtitle = (symbol) => {
  const ticker = symbol?.trim();
  if (!ticker) return 'Insider Information';
  return `${ticker} - Insider Information`;
};

const StockHeader = ({ stock, title, subtitle, rightSection, showStockFollow = true, currentUser, alertIconUrl }) => {
  const headingSubtitle = subtitle || insiderInformationSubtitle(stock.symbol);

  return (
    <div className={style.header}>
      <Container>
        <div className={style.flexSpaceBetween}>
          <div className={style.flex}>
            <StockImg symbol={stock.symbol} alt={stock.name} className={style.logo} />
            <div>
              <h1 className={style.title}>{title || stock.name}</h1>
              <h2 className={style.subtitle}>{headingSubtitle}</h2>
            </div>
          </div>
          {(showStockFollow && stock?.symbol) || rightSection ? (
            <div className={style.actions}>
              {showStockFollow && stock?.symbol ? (
                <StockFollowButton
                  symbol={stock.symbol}
                  displayName={stock.name}
                  sessionSignedIn={Boolean(currentUser)}
                  iconSrc={alertIconUrl}
                  initialFollowing={
                    typeof currentUser?.following_stock === 'boolean'
                      ? currentUser.following_stock
                      : undefined
                  }
                />
              ) : null}
              {rightSection}
            </div>
          ) : null}
        </div>
      </Container>
    </div>
  );
};

StockHeader.propTypes = {
  stock: PropTypes.shape({
    symbol: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  rightSection: PropTypes.node,
  showStockFollow: PropTypes.bool,
  currentUser: PropTypes.shape({
    following_stock: PropTypes.bool,
  }),
};

export default StockHeader;
